/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {ComputedSignal} from '@gongxigames/framework/core';
import {
    $Container,
    ExtendContainerProps,
    FC, getProp, patchEvents
} from '@gongxigames/framework/core/fragments/BuilderY';

type FullScreenButtonProps = Omit<ExtendContainerProps<{
    action?: () => void;
}>, 'hitArea' | 'interactive' | 'buttonMode'>;

const $FullScreenButton: FC<FullScreenButtonProps> = (props) => {
    props.events ??= {};
    patchEvents(props.events, {pointertap: () => getProp(props.action)?.()});

    return <$Container {...props}
        interactive={true}
        buttonMode={true}
        hitArea={{contains: () => true}}
    />;
};

export const renderFullScreenButton = (
    onStartButtonClicked: Function,
    isStartButtonVisible: ComputedSignal<boolean>,
    shouldShowFullScreenButton: boolean
) => {
    return <$FullScreenButton
        name='FullScreenStartButton'
        visible={shouldShowFullScreenButton && !isStartButtonVisible.value}
        action={() => onStartButtonClicked()}
    />;
};